import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LangugeDetector from 'i18next-browser-languagedetector';

import TRANSLATION_DE from './de/translation.json';
import TRANSLATION_FR from './fr/translation.json';
import TRANSLATION_IT from './it/translation.json';
import languages from '../constants/languages';
import {
  getLanguageFromPath,
  isSupportedLanguage,
  normalizeLanguage,
  replacePathLanguage,
  supportedLanguages,
} from '../utils/languageUrl';

const LANGUAGE_STORAGE_KEY = 'i18nextLng';
const DEFAULT_LANGUAGE = languages.DE;

const getBrowserLanguage = () => {
  if (typeof navigator === 'undefined') {
    return DEFAULT_LANGUAGE;
  }

  const browserLanguages = [
    ...(navigator.languages || []),
    navigator.language,
    navigator.userLanguage,
  ].filter(Boolean);

  const supportedBrowserLanguage = browserLanguages.find(isSupportedLanguage);

  return supportedBrowserLanguage
    ? normalizeLanguage(supportedBrowserLanguage)
    : DEFAULT_LANGUAGE;
};

const resolveInitialLanguage = () => {
  const pathLanguage =
    typeof window === 'undefined'
      ? null
      : normalizeLanguage(getLanguageFromPath(window.location.pathname));

  if (pathLanguage && isSupportedLanguage(pathLanguage)) {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, pathLanguage);
    replacePathLanguage(pathLanguage);
    return pathLanguage;
  }

  const storedLanguage = normalizeLanguage(
    localStorage.getItem(LANGUAGE_STORAGE_KEY),
  );

  if (storedLanguage && isSupportedLanguage(storedLanguage)) {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, storedLanguage);
    replacePathLanguage(storedLanguage);
    return storedLanguage;
  }

  const browserLanguage = getBrowserLanguage();
  localStorage.setItem(LANGUAGE_STORAGE_KEY, browserLanguage);
  replacePathLanguage(browserLanguage);
  return browserLanguage;
};

const initialLanguage = resolveInitialLanguage();

i18n
  .use(initReactI18next)
  .use(LangugeDetector)
  .init({
    lng: initialLanguage,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: supportedLanguages,
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    resources: {
      de: { translation: TRANSLATION_DE },
      fr: { translation: TRANSLATION_FR },
      it: { translation: TRANSLATION_IT },
    },
  });

export default i18n;
